import React, { useState, useRef, useCallback, useEffect } from 'react';
import { useEventListener } from 'ahooks';
import { createPortal } from 'react-dom';
import { Rnd } from 'react-rnd';
import { Icon } from '@shakkerai/components';
import { setTempState } from '@starflow/app/store';

export const SubWindow = React.memo((props) => {
  const {
    className,
    width,
    height,
    title,
    name,
    exclusive,
    positionSetter,
    disableHeader = false,
    handleCustomClose,
    children,
    windowId,
  } = props;
  const containerRef = useRef(null);
  const [position, setPosition] = useState(null);

  const handleCloseWindow = useCallback(() => {
    // debugger
    // console.log('xxx name', name)
    setTempState({ exclusiveWindow: windowId || null });
  }, [name, exclusive]);

  const handleGlobalClick = useCallback(
    (event) => {
      if (!position) return;

      if (handleCustomClose) {
        return handleCustomClose?.(event);
      }

      if (containerRef.current?.contains(event.target)) {
        return;
      }

      if (event.target?.closest(`[data-trigger-window="${name}"]`)) {
        return;
      }

      if (event.target?.closest('.mantine-Popover-dropdown')) {
        return;
      }

      handleCloseWindow();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [position, name, handleCloseWindow, handleCustomClose],
  );

  useEventListener('click', handleGlobalClick);

  useEffect(() => {
    setTimeout(() => {
      if (positionSetter) {
        setPosition(positionSetter());
      } else if (width && height) {
        setPosition({
          x: (window.innerWidth - width) / 2,
          y: (window.innerHeight - height) / 2,
        });
      } else {
        setPosition({ x: 10, y: 10 });
      }
    }, 0);
  }, [width, height, positionSetter]);

  if (!position) {
    return null;
  }

  return createPortal(
    <Rnd default={position} scale={1} className="z-[100]" dragHandleClassName="sub-drag-handle">
      <div
        ref={containerRef}
        className={`${className} flex flex-col items-stretch bg-white shadow-light rounded-[2px]`}
      >
        {!disableHeader && (
          <header className="sub-drag-handle flex items-center justify-between h-11 px-4 cursor-move">
            <span className="text-sm text-[#2d2d2d] font-semibold">{title}</span>
            <button onClick={handleCloseWindow}>
              <Icon fontSize={16} className="icon-border_close-1 text-[#222]" />
            </button>
          </header>
        )}
        {children}
      </div>
    </Rnd>,
    document.body,
  );
});
